import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Alert, AlertType } from 'src/app/models/alert.interface';

/**
 * Component for an alert row.
 */
@Component({
    selector: 'app-alert-row',
    templateUrl: './alert-row.component.html',
    styleUrls: ['./alert-row.component.scss'],
    standalone: false
})
export class AlertRowComponent {
    /**
     * The alert to show
     */
    @Input() alert!: Alert;

    /**
     * Emitted when the user dismisses the alert
     */
    @Output() hide = new EventEmitter<Alert>();

    get alertType() {
        return AlertType;
    }
}
